import _ from 'lodash';
export const modifiersDefaultValues = {
  fullyBooked: [],
  partiallyBooked: [],
  disabled: [{ before: new Date() }],
  inquired: [],
  requested: [],
  offerSubmitted: [],
  booking: []
};

export function processMonthEventsToModifiers (monthEvents) {
  if (!monthEvents) {
    return {};
  }

  const newModifiers = { ...modifiersDefaultValues };

  Object.keys(monthEvents).forEach(dayKey => {
    const dayData = monthEvents[dayKey];
    const year = dayData.year;
    const month = dayData.month;
    const date = new Date(year, month - 1, parseInt(dayKey, 10));

    if (dayData.is_fully_booked) {
      newModifiers.fullyBooked.push(date);
    }

    const objStates = (dayData.events ?? []).map((event) => {
      if ('buffer' !== event.type) {
        return event.booking_obj_state;
      }
      return null;
    }).filter(state => state !== null);

    const hasActiveBooking = _.filter(objStates, (state) => 'ACTIVE' === state).length > 0;
    if (hasActiveBooking) {
      newModifiers.booking.push(date);
    }

    const nonActiveObjState = _.filter(objStates, (state) => 'ACTIVE' !== state);
    nonActiveObjState.forEach(state => {
      switch (state) {
        case 'INQUIRED':
          newModifiers.inquired.push(date);
          break;
        case 'REQUESTED':
          newModifiers.requested.push(date);
          break;
        case 'OFFER_SUBMITTED':
          newModifiers.offerSubmitted.push(date);
          break;
        default:
          break;
      }
    });
  });

  return newModifiers;
}
